import CommonRequestService from './common-request-service';

/***
 * A filter for a date range to see if a given date exists between a start and end date.
 */
const commonRequest = angular
    .module('FacilityData.Common.CommonRequest', [])
    .service('CommonRequest', CommonRequestService)
    .name;

export default commonRequest;


// WEBPACK FOOTER //
// ./app/common/common-request/common-request.js